// Non-fatal errors: 600 - 699
export const ERROR_NO_SESSION = 612;
